// extracted by mini-css-extract-plugin
export default {"wrapper":"lz","subscription":"mz","select_item":"nz","is_selected":"oz","otb":"pz","radio":"qz","first_row":"rz","prices":"sz","italic":"tz","info_wrapper":"uz","first_month":"vz","separator":"wz","checkmark":"xz","bullets":"yz","bullet":"zz","checkmarkText":"Az","button":"Bz","discountBadge":"Cz"};
    if(module.hot) {
      // 1713996746829
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  